import { useMutation } from '@tanstack/react-query'
import { ControllingPdfRequestBody } from '@myapp/contract'
import { controllingApi } from '../controllingApi'

export function useGenerateControllingPdfMutation() {
  return useMutation({
    mutationFn: (body: ControllingPdfRequestBody) =>
      controllingApi.generatePdf(body).then((r) => r.data),
    onSuccess: (blob: Blob) => {
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      const date = new Date().toISOString().slice(0, 10)
      a.download = `controlling-export-${date}.pdf`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(url)
    },
  })
}
